import React, { useEffect, useLayoutEffect, useState } from "react";
import { FormControl, FormHelperText, InputLabel, ListSubheader, MenuItem, OutlinedInput, Select } from "@material-ui/core";
import { useIntl } from "react-intl";

import { useGPTModels } from "../hooks/useGPTModels";
import { useGetSettingGPT } from "../hooks/useGetSettingGPT";
import { useEditSettingGPT } from "../hooks/useEditSettingGPT";
import { useStyles } from "../hooks/useStyles";
import Preloader from "../../../../components/ui/Loaders/Preloader";
import ButtonWithLoader from "../../../../components/ui/Buttons/ButtonWithLoader";

export function Settings() {
  const classes = useStyles();
  const intl = useIntl();
  const { fetchModels, loadingModels, models } = useGPTModels();
  const [model, setModel] = useState<string | undefined>(undefined);
  const [model2, setModel2] = useState<string | undefined>(undefined);
  const { fetchSetting: fetchSettingModel, loading: loadingModel, setting: settingModel } = useGetSettingGPT();
  const { fetchSetting: fetchSettingModel2, loading: loadingModel2, setting: settingModel2 } = useGetSettingGPT();
  const { fetchSettingEdit: fetchSettingEditModel, loadingEdit: loadingEditModel } = useEditSettingGPT();
  const { fetchSettingEdit: fetchSettingEditModel2, loadingEdit: loadingEditModel2 } = useEditSettingGPT();

  useLayoutEffect(() => {
    fetchModels();
    fetchSettingModel("model");
    fetchSettingModel2("model_2");
  }, []);

  const mainRecommend = models.filter(i => i.id === "o4-mini" || i.id === "o3-mini" || i.id === "gpt-4.1");
  const reserveRecommend = models.filter(i => i.id === "gpt-4.1-mini");

  useEffect(() => {
    if (settingModel && settingModel2) {
      setModel(settingModel?.value);
      setModel2(settingModel2?.value);
    }
  }, [settingModel, settingModel2]);

  if (loadingModel || loadingModel2 || loadingModels) {
    return (
      <div className={classes.preloader}>
        <Preloader />
      </div>
    );
  }

  return (
    <div className={classes.form}>
      <FormControl className={classes.formControl} variant="outlined">
        <InputLabel shrink>{intl.formatMessage({ id: "MAIN.MODEL" })}</InputLabel>
        <Select
          value={model}
          input={<OutlinedInput notched label={intl.formatMessage({ id: "MAIN.MODEL" })} />}
          onChange={e => setModel(e.target.value as string)}
          variant="outlined"
        >
          {mainRecommend.length > 0 && <ListSubheader>{intl.formatMessage({ id: "RECOMMENDED" })}</ListSubheader>}
          {mainRecommend.map(i => (
            <MenuItem key={i.id} value={i.id}>
              {i.id}
            </MenuItem>
          ))}
          <ListSubheader>{intl.formatMessage({ id: "OTHERS" })}</ListSubheader>
          {models
            .filter(i => i.id !== "o4-mini" && i.id !== "o3-mini" && i.id !== "gpt-4.1")
            .map(i => (
              <MenuItem key={i.id} value={i.id}>
                {i.id}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl className={classes.formControl} variant="outlined">
        <InputLabel shrink>{intl.formatMessage({ id: "RESERVE.MODEL" })}</InputLabel>
        <Select
          input={<OutlinedInput notched label={intl.formatMessage({ id: "RESERVE.MODEL" })} />}
          value={model2}
          onChange={e => setModel2(e.target.value as string)}
          variant="outlined"
        >
          {reserveRecommend.length > 0 && <ListSubheader>{intl.formatMessage({ id: "RECOMMENDED" })}</ListSubheader>}
          {reserveRecommend.map(i => (
            <MenuItem key={i.id} value={i.id}>
              {i.id}
            </MenuItem>
          ))}
          <ListSubheader>{intl.formatMessage({ id: "OTHERS" })}</ListSubheader>
          {models
            .filter(i => i.id !== "gpt-4.1-mini")
            .map(i => (
              <MenuItem key={i.id} value={i.id}>
                {i.id}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{intl.formatMessage({ id: "RESERVE.MODEL.HELPER" })}</FormHelperText>
      </FormControl>
      <ButtonWithLoader
        loading={loadingEditModel || loadingEditModel2}
        disabled={loadingEditModel || loadingEditModel2}
        onPress={() => {
          fetchSettingEditModel({
            type: "model",
            value: model,
          });
          fetchSettingEditModel2({
            type: "model_2",
            value: model2,
            disableSuccess: true,
          });
        }}
      >
        {intl.formatMessage({ id: "COMMON.BUTTON.SAVE" })}
      </ButtonWithLoader>
    </div>
  );
}
